<script setup>
import { ref } from 'vue';
import { useForm, Head, Link } from '@inertiajs/vue3';
import { RegisterForm } from '@goodvibes/kudoslink';
import SignupLayout from '@/Layouts/SignupLayout.vue';
import HoneypotInputs from '@/Components/HoneypotInputs.vue';

const props = defineProps({
    honeypot: Object,
});

const form = useForm({
    name: '',
    email: '',
    password: '',
    [props.honeypot.nameFieldName]: ref(''),
    [props.honeypot.validFromFieldName]: ref(props.honeypot.encryptedValidFrom),
    terms: false,
});

const submit = () => {
    form.post(
        route('register'),
        { preserveState: true },
        {
            onFinish: () => form.reset('password', 'password_confirmation'),
        },
    );
};
</script>

<template>
    <Head>
        <link rel="canonical" :href="route('register')" />
    </Head>
    <SignupLayout pageTitle="Sign up | Feedbeo">
        <RegisterForm
            v-model:name="form.name"
            v-model:email="form.email"
            v-model:password="form.password"
            :googleRedirectRoute="route('login.social', { provider: 'google' })"
            :azureRedirectRoute="route('login.social', { provider: 'azure' })"
            :termsRoute="route('terms')"
            :loginRoute="route('login')"
            :processing="form.processing"
            :errors="form.errors"
            @submit="submit"
        >
            <HoneypotInputs
                v-if="honeypot.enabled"
                v-model:nameField="form[props.honeypot.nameFieldName]"
                v-model:validFromField="form[props.honeypot.validFromFieldName]"
                :nameFieldName="honeypot.nameFieldName"
                :validFromFieldName="honeypot.validFromFieldName"
            />
        </RegisterForm>
    </SignupLayout>
</template>
